const grouppings = {
  2713: [2713, 2714, 2715, 2716],
  66: [66, 2775, 2774],
};

export const expandedMarketTypeIds = (marketTypeId) => (
  grouppings[marketTypeId] ? grouppings[marketTypeId] : [marketTypeId]
);

export default {};
